// @import dependencies
import React, {Component, CSSProperties} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import parse from 'html-react-parser';
// @end

// @import components
import {DataTableCommonLayout} from 'app_components/commons/dataTable'
import AvatarComponent from 'app_components/commons/avatar'
import CircleComponent from 'app_components/commons/circle'
// @end

// @import events
// @end

// @import utils
import {I18nUtil} from 'app_utils/i18n'
// @end

// @import services
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @ADD Component types

export type TypeFormatsDataTable = 'date' | undefined;
export type TypeTextAlignDataTable = 'left' | 'right' | 'center';
export interface IDataTableHeaderColStyle {
  key: string
  style: CSSProperties
}
export interface IDataTableHeaderColId {
  index: number
  id: string
}

interface IDataTableCommonProps {
  data: any[] | boolean,
  keys: string[],
  tooltipKeys?: string[]
  detailsKey?: any[]
  headerKeys?: string[] | React.ReactNode[]
  sortKeys?: object[]
  formats?: TypeFormatsDataTable[];
  selectedRow?: null | string
  pagination?: IPagination
  module?: string
  hideTooltip?: boolean
  textAlign?: TypeTextAlignDataTable;
  rowButtons?: ((row: any) => React.ReactNode)
  firstColRowButtons?: ((row: any) => React.ReactNode)
  headerButtons?: (() => React.ReactNode)
  onPageChange?: (page: number) => void
  onClickRow?: (row: any) => void
  onSearch?: (query: string) => any
  onAddRow?: (show: boolean) => void,
  onEditRow?: (edit: boolean, row: any) => void
  onRemoveRow?: (id: string) => void
  onUpload?: () => void
  onDownload?: () => void
  onViewerRow?: (edit: boolean, row: any) => void
  onModal?: any
  onBtnComponentAdd?: any
  titleBtn?: string
  onBtnAdd?: boolean
  handleBtnAdd?: () => void
  emptyMessage?: any
  searchFormInputs?: any
  actionsColTitle?: string
  headerStyles?: IDataTableHeaderColStyle[]
  headerIds?: IDataTableHeaderColId[]
}
interface IDataTableCommonState {
  sort: object | null
  dataSorted: any[]
  sortDirection: 'upward' | 'falling'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class DataTableCommon extends Component<IDataTableCommonProps, IDataTableCommonState> {

  private i18nUtil: I18nUtil
  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IDataTableCommonProps) {
    super(props)
    this.i18nUtil = new I18nUtil()
    this.state = {
      sort: null,
      dataSorted: [],
      sortDirection: 'falling',
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onClickRow = async (row: any) => {
    if (this.props.onClickRow) {

      return this.props.onClickRow(row)
    }

    return false
  }

  getValue = (target: string, object: any, options?: any): any => {
    const keys: string[] = target.trim().split('.')

    for(let i = 0 ; i < keys.length; i++){
      const key = keys[i]

      const keyIndex: number = keys.indexOf(key)
      let nextTarget: string[] = [...keys]

      if (keyIndex >= 0) {
        nextTarget = nextTarget.slice(keyIndex + 1)
      }

      if (typeof object[key] === 'boolean') {
        return (object[key] === true) ? this.i18nUtil.getTranslate('components.dataTable.boolean.true') : this.i18nUtil.getTranslate('components.dataTable.boolean.false')
      }

      if (!key || !object[key]) {
        return ''
      }

      if (key.includes('component_render') && !!object[key]) {
        return (object[key])
      }

      if (typeof object[key] === 'string' || typeof object[key] === 'number') {
        //console.log('is string or number', object[key])
        if (key === 'avatar' && !!object[key]) {
          return (<AvatarComponent src={object[key]} size='32px' key={i} rounded />)
        }

        if (key === 'circle_component' && !!object[key]) {
          return (<CircleComponent size='15px'  key={i} color={object[key]} />)
        }

        if (key.includes('html_render') && !!object[key]) {
          return (parse(object[key]))
        }

        if (options?.listItem === true) {
          return (
            <span key={i} className='badge badge-secondary ml-1'>
              {object[key]}
            </span>
          )
        }
        return `${object[key]} `
      }

      if (object[key] instanceof Array) {
        //console.log('is array', object[key])
        keys.splice(keyIndex + 1, 1)

        return object[key].map((element: any, j: number) =>
          this.getValue(nextTarget.join('.'), element, { listItem: true }))
      }

      if (typeof object[key] === 'object' && !(object[key] instanceof Array)) {
        //console.log('is object', object[key])
        return this.getValue(nextTarget.join('.'), object[key], options)
      }

      return ''
    }
    return ''
  }

  sortBy = (sortKey: any, data: any[]) => {
    if (this.props.headerKeys) {
      const key: string = this.props.keys[this.props.headerKeys.findIndex((element: any) => element === sortKey.key)]

      this.setState({
        sort: sortKey,
      })

      let direction = this.state.sortDirection
      if (this.state.sort) {
        if (direction === 'falling') {
          direction = 'upward'
        } else if (direction === 'upward') {
          direction = 'falling'
        }
      }

      let newData = []
      if (direction === 'upward') {

        if(sortKey.type === 'number'){
          newData = data.sort((a: any, b: any) => {
            if (parseInt(a[key]) > parseInt(b[key])) {
              return -1
            }
            if (parseInt(b[key]) >parseInt(a[key])) {
              return 1
            }
            return 0
          })
        } else {
          newData = data.sort((a: any, b: any) => {
            if (a[key] > b[key]) {
              return -1
            }
            if (b[key] > a[key]) {
              return 1
            }
            return 0
          })
        }

      } else if (direction === 'falling') {

        if(sortKey.type === 'number'){
          newData = data.sort((a: any, b: any) => {
            if (parseInt(a[key]) > parseInt(b[key])) {
              return 1
            }
            if (parseInt(b[key]) >parseInt(a[key])) {
              return -1
            }
            return 0
          })
        } else {
          newData = data.sort((a: any, b: any) => {
            if (a[key] > b[key]) {
              return 1
            }
            if (b[key] > a[key]) {
              return -1
            }
            return 0
          })
        }

      }

      this.setState({
        dataSorted: newData,
        sortDirection: direction,
      })
    }
  }

  onPageChange = (page: number) => {
    if (this.props.onPageChange) {
      this.setState({
        sort: null,
        dataSorted: [],
        sortDirection: 'falling',
      })
      this.props.onPageChange(page)
    }
  }

  render() {
    const keys = this.props.keys.map((key: string) => key.split(','))

    return(
      <DataTableCommonLayout
        module={this.props.module}
        data={this.state.dataSorted.length > 0 ? this.state.dataSorted : this.props.data}
        keys={keys}
        headerKeys={this.props.headerKeys}
        formats={this.props.formats}
        sort={this.state.sort}
        sortDirection={this.state.sortDirection}
        sortKeys={this.props.sortKeys}
        sortBy={this.sortBy}
        detailsKey={this.props.detailsKey}
        pagination={this.props.pagination}
        selectedRow={this.props.selectedRow}
        hideTooltip={this.props.hideTooltip}
        textAlign={this.props.textAlign}
        tooltipKeys={this.props.tooltipKeys}
        rowButtons={this.props.rowButtons}
        firstColRowButtons={this.props.firstColRowButtons}
        headerButtons={this.props.headerButtons}
        onAddRow={this.props.onAddRow}
        onClickRow={this.props.onClickRow ? this.onClickRow : undefined}
        onRemoveRow={this.props.onRemoveRow}
        onEditRow={this.props.onEditRow}
        onViewerRow={this.props.onViewerRow}
        onPageChange={this.onPageChange}
        onSearch={this.props.onSearch}
        onDownload={this.props.onDownload}
        onUpload={this.props.onUpload}
        onModal={this.props.onModal}
        getValue={this.getValue}
        onBtnAdd={this.props.handleBtnAdd}
        onBtn={this.props.onBtnAdd}
        titleBtn={this.props.titleBtn}
        onBtnComponentAdd={this.props.onBtnComponentAdd}
        emptyMessage={this.props.emptyMessage}
        searchFormInputs={this.props.searchFormInputs}
        actionsColTitle={this.props.actionsColTitle}
        headerStyles={this.props.headerStyles}
        headerIds={this.props.headerIds}
      />
    )
  }
}

export default connect(mapStatesToProps)(DataTableCommon)
